import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import Select from 'react-select';
import themedColor, {
  ThemedColorReturn
} from '../../../../styles/theme/themed-color';
import themedFontSize from '../../../../styles/theme/themed-font-size';
import styleUtils from '../../../../styles/style.utils';
import mediaBreakpoints from '../../../../styles/media-breakpoints';

const FontStyle = css`
  color: ${themedColor('TEXT_BLUE')};
  font-size: ${themedFontSize('FORM')};
  font-weight: 400;
`;
interface ContainerProps {
  customWidth?: string;
}
const Container = styled.div<ContainerProps>`
  margin-bottom: ${styleUtils.px(18)};
  width: 100%;

  ${({ customWidth }: ContainerProps): FlattenSimpleInterpolation =>
    mediaBreakpoints.greaterThan('M')`
      // IE 11 hack
      flex-basis:  calc(${customWidth || `50%`} - 32px);
     
      @supports (display: grid) {
       flex-basis:  ${customWidth || `50%`};
      }
  `};
`;

interface SelectProps {
  reverseColors: boolean;
}
const StyledSelect = styled(Select)<SelectProps>`
  .Ucf-select__control {
    height: ${styleUtils.px(40)};
    background: ${({ reverseColors }: SelectProps): ThemedColorReturn =>
      reverseColors ? themedColor('INPUT_BG') : themedColor('GRAY')};
    border: ${styleUtils.px(1)} solid ${themedColor('INPUT_BORDER')};
    border-radius: ${styleUtils.px(20)};
    padding: 0 ${styleUtils.px(8)};
    min-width: ${styleUtils.size('MIN_INPUT_WIDTH')};
    z-index: 2;
    ${FontStyle};
  }

  .Ucf-select__placeholder {
    ${FontStyle};
    color: ${themedColor('DARK_GREY')};
  }

  .Ucf-select__control:hover {
    border-color: ${themedColor('INPUT_FOCUS_BORDER')};
  }

  .Ucf-select__control--menu-is-open {
    background: ${themedColor('INPUT_BG')};
    color: ${themedColor('DARK_GREY')};
  }

  .Ucf-select__control--is-focused {
    border: 1px solid ${themedColor('INPUT_FOCUS_BORDER')};
    outline: none;
    z-index: 4;
  }

  .Ucf-select__indicator svg {
    fill: ${themedColor('TEXT_GREY')};
  }
  .Ucf-select__indicator-separator {
    display: none;
  }

  .Ucf-select__menu {
    padding-top: ${styleUtils.px(32)};
    margin-top: ${styleUtils.px(-16)};
    width: calc(100% - ${styleUtils.px(4)});
    left: ${styleUtils.px(2)};
    right: ${styleUtils.px(2)};
    z-index: 3;
  }

  .Ucf-select__option {
    padding: ${styleUtils.px(12)} ${styleUtils.px(24)};
    ${FontStyle};

    &.Ucf-select__option--is-focused {
      background: ${themedColor('INPUT_FOCUS_BG')};
    }
    &.Ucf-select__option--is-selected {
      background: ${themedColor('GRAY')};
    }
  }

  .Ucf-select__input input {
    border: 1px solid ${themedColor('INPUT_BORDER')};
    ${FontStyle}
  }

  .Ucf-select__single-value {
    height: ${styleUtils.px(24)};
    display: flex;
    align-items: center;
    color: ${themedColor('TEXT_BLUE')};
  }

  &:focus {
    outline: 0;
    border-color: ${themedColor('TEXT_BLUE')};
  }
`;

const FormSelectComponents = { StyledSelect, Container };

export default FormSelectComponents;
